import { render } from "./About.vue?vue&type=template&id=1c7ac75c&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=1c7ac75c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c7ac75c"

export default script